import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { FormikProps } from 'formik'

import GoalBudgetFields from './GoalBudgetFields'
import GoalImpressionFields from './GoalImpressionFields'
import CostCapApproachQuestionComponent from '../../../../../Facebook/UploadFacebookAdCreative/UploadFacebookAdCreativeForm/CampaignForm/NewCampaignFields/NewCampaignBudgetAllocationFields/CostCapApproachQuestion'

import useGetAppsData from '../../../../../Facebook/UploadFacebookAdCreative/UploadFacebookAdCreativeForm/reusableFields/AppListField/useGetAppsData'
import useRightBudgetAndImpressionsCalculation from '../../../../../Multiplatform/UploadAdCreative/useRightBudgetAndImpressionsCalculation'

import { rightSelector } from '../../../../../../modules/selectors/rights'

import {
  DIGITAL_ALLOCATION_TYPE_BUDGET,
  DIGITAL_ALLOCATION_TYPE_IMPRESSIONS
} from '../../../../Partnerships/RightForms/fields'
import { OBJECTIVE } from '../../../../CampaignForms/fields'
import { OUTCOME_APP_PROMOTION, OUTCOME_SALES, OUTCOME_TRAFFIC } from '../../../../../../constants/campaigns'
import { BIDDING_TYPE } from '../../../../../Facebook/CampaignForms/CampaignFacebookCreate/CampaignFacebookCreateForm/fields'

// Type-safe aliases to avoid TypeScript errors with JS components
const CostCapApproachQuestion = CostCapApproachQuestionComponent as any

interface GoalFieldsProps {
  formik: FormikProps<any>
}

const GoalFields: React.FC<GoalFieldsProps> = ({ formik }) => {
  const right = useSelector(rightSelector)

  const { values, setFieldValue } = formik
  const { allocation_type: rightAllocationType } = right

  const isBudgetAllocationType = rightAllocationType === DIGITAL_ALLOCATION_TYPE_BUDGET
  const isImpressionAllocationType = rightAllocationType === DIGITAL_ALLOCATION_TYPE_IMPRESSIONS

  const { remainingBudget, remainingImpressions } = useRightBudgetAndImpressionsCalculation()

  const showCostCapSection = useMemo(
    () =>
      isBudgetAllocationType &&
      (values[OBJECTIVE] === OUTCOME_SALES ||
        values[OBJECTIVE] === OUTCOME_TRAFFIC ||
        values[OBJECTIVE] === OUTCOME_APP_PROMOTION),
    [isBudgetAllocationType, values]
  )

  useGetAppsData()

  return (
    <>
      {isBudgetAllocationType && <GoalBudgetFields formik={formik} remainingBudget={remainingBudget} />}
      {isImpressionAllocationType && (
        <GoalImpressionFields formik={formik} remainingImpressions={remainingImpressions} />
      )}
      {/* todo move on campaign fields level*/}
      {showCostCapSection && (
        <CostCapApproachQuestion setFieldValue={setFieldValue} biddingType={values[BIDDING_TYPE]} />
      )}
    </>
  )
}

export default GoalFields
